import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_4 = { class: "bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4" }
const _hoisted_5 = { class: "sm:flex sm:items-start" }
const _hoisted_6 = { class: "mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10" }
const _hoisted_7 = { class: "mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left" }
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = { class: "text-sm text-gray-500" }
const _hoisted_10 = { class: "bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6" }

import {ComponentInternalInstance, ref} from 'vue';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {ExclamationTriangleIcon, CheckIcon, ExclamationCircleIcon} from '@heroicons/vue/24/outline';
import IModalDialogData from "@/interfaces/IModalDialogData";

import {getCurrentInstance} from 'vue'
import {useI18n} from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalDialog',
  setup(__props) {

const {t} = useI18n();
const open = ref(false);

const app: ComponentInternalInstance | null = getCurrentInstance();
//@ts-ignore
const {emitter} = app.appContext.config.globalProperties;

const text = ref<string>("");
const title = ref<string>("");
const showBtnSuccess = ref<boolean>(false);
const showBtnCancel = ref<boolean>(true);
const textBtnSuccess = ref<string>("");
const textBtnCancel = ref<string>("");
const type = ref<string>("");
const isConfirm = ref<boolean>(false);
const callbackSuccess = ref();
const callbackCancel = ref();

emitter.on("modal", (data: IModalDialogData) => {
  isConfirm.value = data.isConfirm ?? false;
  text.value = data.text ?? "";
  title.value = data.title ?? "";
  showBtnSuccess.value = data?.showBtnSuccess ?? false;
  showBtnCancel.value = data?.showBtnCancel ?? false;
  callbackSuccess.value = data.callbackSuccess ?? undefined;
  callbackCancel.value = data.callbackCancel ?? undefined;
  textBtnSuccess.value = data.textBtnSuccess ?? t("components.ModalDialog.btnApply");
  textBtnCancel.value = data.textBtnCancel ?? t("components.ModalDialog.btnCancel");
  type.value = data.type ?? undefined;
  open.value = true;
});

const onClickSuccess = () => {
  open.value = false;
  if (callbackSuccess.value) {
    callbackSuccess.value();
  }
};

const onClickCancel = () => {
  open.value = false;
  if (callbackCancel.value) {
    callbackCancel.value();
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: open.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-10",
        onClose: _cache[0] || (_cache[0] = ($event: any) => (open.value = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            (type.value === 'error')
                              ? (_openBlock(), _createBlock(_unref(ExclamationCircleIcon), {
                                  key: 0,
                                  class: "h-6 w-6 text-red-600",
                                  "aria-hidden": "true"
                                }))
                              : _createCommentVNode("", true),
                            (type.value === 'success')
                              ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                  key: 1,
                                  class: "h-6 w-6 text-green-600",
                                  "aria-hidden": "true"
                                }))
                              : _createCommentVNode("", true),
                            (type.value === 'warning')
                              ? (_openBlock(), _createBlock(_unref(ExclamationTriangleIcon), {
                                  key: 2,
                                  class: "h-6 w-6 text-orange-600",
                                  "aria-hidden": "true"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_unref(DialogTitle), {
                              as: "h3",
                              class: "text-base font-semibold leading-6 text-gray-900"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(title.value), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("p", _hoisted_9, _toDisplayString(text.value), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        (showBtnCancel.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto",
                              onClick: onClickCancel
                            }, _toDisplayString(textBtnCancel.value), 1))
                          : _createCommentVNode("", true),
                        (showBtnSuccess.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto",
                              onClick: onClickSuccess,
                              ref: "cancelButtonRef"
                            }, _toDisplayString(textBtnSuccess.value), 513))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})